import { render, staticRenderFns } from "./ProdProcesList.vue?vue&type=template&id=1ec6bb02&scoped=true&"
import script from "./ProdProcesList.vue?vue&type=script&lang=js&"
export * from "./ProdProcesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6bb02",
  null
  
)

export default component.exports